export const REPLACEMENT_LEAVE_VALUES = [0, 0.5, 1, 1.5];

export const REPLACEMENT_LEAVE_OPTIONS = REPLACEMENT_LEAVE_VALUES.map((o) => ({ label: o.toString(), value: o.toString() }));

const RECOMMENDATION_MAX_HOURS = 12;

// Allowed overtime dates: 1 month before (today and future excluded)
export const getOvertimeDateRange = () => {
	const minDate = new Date();
	const maxDate = new Date();

	minDate.setHours(0, 0, 0, 0);
	maxDate.setHours(0, 0, 0, 0);

	minDate.setMonth(minDate.getMonth() - 1);
	maxDate.setDate(maxDate.getDate() - 1);

	return { minDate, maxDate };
};

export const isOvertimeDateInRange = (date) => {
	if (!date) return false;

	const { minDate, maxDate } = getOvertimeDateRange();
	const value = new Date(date);

	value.setHours(0, 0, 0, 0);

	return value >= minDate && value <= maxDate;
};

const toMinutes = (time) => {
	if (!time) return null;

	const [hours, minutes] = time.split(":");

	if (isNaN(hours) || isNaN(minutes)) return null;

	return parseInt(hours) * 60 + parseInt(minutes);
};

// Same day only, so end must be strictly after start
export const isEndTimeAfterStartTime = (startTime, endTime) => {
	const start = toMinutes(startTime);
	const end = toMinutes(endTime);

	if (start === null || end === null) return false;

	return end > start;
};

export const calculateOvertimeHours = (startTime, endTime) => {
	const start = toMinutes(startTime);
	const end = toMinutes(endTime);

	if (start === null || end === null || end <= start) return 0;

	return Math.round(((end - start) / 60) * 100) / 100;
};

export const getRecommendedReplacementLeave = (hours) => {
	const cappedHours = Math.min(hours || 0, RECOMMENDATION_MAX_HOURS);

	if (cappedHours >= 12) return 1.5;
	if (cappedHours >= 8) return 1;
	if (cappedHours >= 4) return 0.5;

	return 0;
};

export const getRecommendedReplacementLeaveByTime = (startTime, endTime) => {
	return getRecommendedReplacementLeave(calculateOvertimeHours(startTime, endTime));
};

export const getReplacementLeaveOptions = (max) => {
	if (max === undefined || max === null) return REPLACEMENT_LEAVE_OPTIONS;

	return REPLACEMENT_LEAVE_OPTIONS.filter((o) => parseFloat(o.value) <= max);
};
